import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppointmentCreateComponent} from '../../../pages/dialogs/appointment-create/appointment-create.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DoctorService} from '../../../core/services/curd/doctor.service';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PatientsService} from '../../../core/services/curd/patients.service';
import {ChannelingCenterService} from '../../../core/services/curd/channeling-center.service';
import {AppointmentsService} from '../../../core/services/curd/appointments.service';
import {formatDate} from '@angular/common';
import {AuthService} from '../../../core/services/misc/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  country_list = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor L\'Este', 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'];
  countrySelected = 'Sri Lanka';
  filtered_countries_select: any = [];
  appointment_data: any = [];
  doctor_name: any;
  closeModal: string;
  patients_list: any = [];
  search_results: any = [];
  keyword = '';
  slot: any;

  patients_form = new FormGroup({
    name: new FormControl('', Validators.required),
    nic: new FormControl(''),
    mobile: new FormControl(''),
    dob: new FormControl(''),
    gender: new FormControl(''),
    address: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl(''),
  });

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private doctorService: DoctorService,
    private modalService: NgbModal,
    private patientsService: PatientsService,
    private hospital: ChannelingCenterService,
    private booking: AppointmentsService,
    private auth: AuthService
  ) {
  }

  ngOnInit(): void {
    this.loadDoctorInfo();
    this.loadCountriesSelect();

  }

  loadCountriesSelect() {
    this.filtered_countries_select = [];
    for (let country of this.country_list) {
      let select_item = {
        value: country,
        label: country,
        data: country
      };
      this.filtered_countries_select.push(select_item);
    }
  }


  profileInfo() {
    this.router.navigate(['doctor/profile']);
  }

  createAppointment() {
    const ref = this.matDialog.open(AppointmentCreateComponent, {
      panelClass: 'new-custom-test'

    });
  }

  loadDoctorInfo() {
    this.doctorService.list().then(res => {
      this.doctor_name = res[0].doctor_name;
    });
  }

  homePageLink() {
    this.router.navigate(['start']);
  }

  triggerModal(content) {
    this.slot = JSON.parse(localStorage.getItem('slot'));
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then((res) => {
      this.closeModal = `Closed with: ${res}`;
    }, (res) => {
      this.closeModal = `Dismissed ${this.getDismissReason(res)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  toggleMenu() {
    let logo = document.getElementById('logo-img');
    let logo_sm = document.getElementById('logo-img-sm');
    let display = window.getComputedStyle(document.querySelector('#logo-img')).display;
    if (display == 'inline') {
      logo.style.display = 'none';
      logo_sm.style.display = 'inline';
    } else {
      logo.style.display = 'inline';
      logo_sm.style.display = 'none';
    }
    document.body.classList.toggle('enlarge-menu');
  }

  loadPatients() {
    this.patientsService.list().then(res => {
      this.patients_list = res;
    });
  }

  search() {
    this.patientsService.list().then(res => {
      this.patients_list = res;
      console.log(this.patients_list);
      this.search_results = this.patients_list.filter(
        obj => obj.name.toUpperCase().includes(this.keyword.toUpperCase()) || obj.nic.toUpperCase().includes(this.keyword.toUpperCase())
          || obj.mobile.includes(this.keyword) || obj.patient_id.includes(this.keyword.toUpperCase())
      );
    });
  }

  updateAppointment(patient: any, has_next = false) {
    let hospital = this.slot.hospital;
    this.hospital.list().then(res => {
      // @ts-ignore
      res = res.filter(ob => ob.channeling_center_name == hospital)[0];
      const input = {
        token: 0,
        type: 'visit',
        channeling_center_name: hospital,
        channeling_center_id: res['_id'],
        slot_id: this.slot.slot_id,
        slot_date: this.slot.date,
        visit_id: formatDate(Date.now(), 'yyMMddHHmmss', 'en-US'),
        patient_id: patient._id,
        patient_name: patient.name,
        medical_name: patient.patient_id,
        booking_name: '',
        booking_phone: ''
      };
      this.booking.create(input).then(data => {
        if (!has_next) {
          this.modalService.dismissAll();
        }
      });
    });
  }

  createNewAndLink(has_next) {
    let date_id = formatDate(Date.now(), 'yyMMddHHmmss', 'en-US');
    date_id = date_id.replace(date_id.charAt(0), '1');
    const input_data = this.patients_form.value;
    input_data['patient_id'] = date_id;
    this.patientsService.create(input_data).then(res => {
      const patient = {
        _id: res['data'],
        name: input_data.name,
        patient_id: date_id
      };
      this.patients_form.reset();
      this.updateAppointment(patient, has_next);
    });
  }

  logout() {
    this.auth.logout();
  }
}
